import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { api, fmtDate } from "@/lib/api";

const Arrow = ({ a, b }) => (a || b) ? <span className="font-mono">{a || "—"} → {b || "—"}</span> : null;

const Entry = ({ e, i }) => (
  <li className="relative pl-6" data-testid={`code-history-event-${i}`}>
    <span className={`absolute left-0 top-1.5 h-2.5 w-2.5 rounded-full ${e.event === "gap" ? "bg-slate-300" : e.scope_before !== e.scope_after && e.scope_after ? "bg-[#D52B3B]" : "bg-slate-500"}`} />
    {e.event === "gap" ? (
      <p className="text-sm italic text-slate-500" data-testid="code-history-gap">{e.label}. <span className="not-italic text-xs">{e.note}</span></p>
    ) : (
      <div className="text-sm">
        <p className="font-medium text-slate-900">{e.label} <span className="ml-1 text-xs font-normal text-slate-500">{fmtDate(e.at, true)} · Plant {e.plant || "—"}</span></p>
        <p className="mt-0.5 flex flex-wrap gap-x-4 text-xs text-slate-600">
          {(e.old_code || e.new_code) && e.old_code !== e.new_code && <span>Code <Arrow a={e.old_code} b={e.new_code} /></span>}
          {(e.scope_before || e.scope_after) && <span>Scope {e.scope_before_label || "—"} → {e.scope_after_label || "—"}</span>}
        </p>
        <p className="mt-0.5 text-xs text-slate-500">
          By {e.by || "—"}
          {e.filename && <> · {e.upload_id ? <Link className="text-[#D52B3B] hover:underline" to={`/code-changes/${e.upload_id}`}>{e.filename}</Link> : e.filename}</>}
          {e.reason && <> · {e.reason}</>}
          {e.backfilled && <> · from earlier records</>}
        </p>
      </div>
    )}
  </li>
);

export const CodeHistory = ({ material }) => {
  const [d, setD] = useState(null);
  useEffect(() => { api.get(`/materials/by-number/${encodeURIComponent(material)}/code-history`).then((r) => setD(r.data)).catch(() => setD({ events: [] })); }, [material]);
  if (!d) return <Loader2 className="m-4 h-4 w-4 animate-spin text-slate-400" />;
  return <ol className="space-y-3 border-l border-slate-200 py-2 pl-3" data-testid="code-history-list">{d.events.map((e, i) => <Entry key={i} e={e} i={i} />)}</ol>;
};
